export const getTitle = (title: string | undefined): string => {
  return title ? title : '';
};
